/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Fmt_2Inputs */

const en_pc_online_fmt_2 = /** @type {(inputs: Pc_Online_Fmt_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves PDF. Edits are appended as an incremental update, and encrypted files stay encrypted.`)
};

const zh_pc_online_fmt_2 = /** @type {(inputs: Pc_Online_Fmt_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存为 PDF。修改以增量更新的方式追加，加密文件保存后仍保持加密。`)
};

/**
* | output |
* | --- |
* | "Saves PDF. Edits are appended as an incremental update, and encrypted files stay encrypted." |
*
* @param {Pc_Online_Fmt_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_fmt_2 = /** @type {((inputs?: Pc_Online_Fmt_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Fmt_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_fmt_2(inputs)
	return zh_pc_online_fmt_2(inputs)
});
export { pc_online_fmt_2 as "pc.online.fmt.2" }